import createAsyncReducer from '../../core/helpers/createAsyncReducer';
import { STATISTICS_TYPES} from '../../core/constants/actionTypes';


export const competitionsTablesReducer = createAsyncReducer(STATISTICS_TYPES.GET_COMPETITIONS_TABLES.PREFIX, {});
export const matchStatsReducer = createAsyncReducer(STATISTICS_TYPES.GET_MATCH_STAT.PREFIX, {});
